import React, {Button, Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import _ from '../../utils/languages/languages';
import GetEventsListService from '../../services/getEventsList';
import EventsTable from '../../widgets/tables/EventsTable';

export default class GeneralListPage extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.eventslist = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false
    }

    this.grid = 2;

    this.defaultList = [];
    this.pageTitle = "Events list";

    this.state = {

    };

  }

  async reload(){
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    this.eventslist = await GetEventsListService(username, token);

    this.setState({});
  }


  async componentDidMount(){

    this.reload();
  }

  render () {

    const defaultFontValue = {
      fontFamily: 'Montserrat',
      fontSize: 21,
      color: '#555555'
    }

    var headCells = [
      { id: 'eventName', numeric: false, disablePadding: true, label: 'Event name' },
      { id: 'startDate', numeric: true, disablePadding: false, label: 'Start Date' },
      { id: 'endDate', numeric: true, disablePadding: false, label: 'End Date' },
    ];

    function createData(eventName, startDate, endDate, id) {
      return { eventName, startDate, endDate, id, id };
    }

    var rows = [];
    this.eventslist.length > 0 && this.eventslist.map((v, k) => {
      rows.push(createData(v.eventName, v.startDate, v.endDate, parseInt(v.eventId)));
    });

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={_.tr('Loading your content...')}
      >
        <PageTitle title={this.pageTitle} button="ADD" onClick={() => {
          window.location.href = '/#/app/newevent';
        }} />
        <EventsTable headCells={headCells} rows={rows} reloadCall={() => {this.reload()}} onEventClick={(eventName, eventId) => {
          if (window.confirm("Change the current event?")) {
            const cookies = new Cookies();
            cookies.set('currentEventName', eventName, { path: '/' });
            cookies.set('currentEventId', eventId, { path: '/' });
            this.eventslist.map((v) => {
              if (v.eventId == eventId){
                cookies.set('currentEventStartHour', v.startHour, { path: '/' });
                cookies.set('currentEventStartMinutes', v.startMinutes, { path: '/' });
                cookies.set('currentEventEndHour', v.endHour, { path: '/' });
                cookies.set('currentEventEndMinutes', v.endMinutes, { path: '/' });
              }
            });
            window.location.href= '#/app/eventdetails';
            //window.location.reload();
          }
        }}/>

        </LoadingOverlay>
      </>
    );
  }

}

